import { Component, Input, OnInit } from '@angular/core';
import { MerchantModel } from '../../../shared/models/merchant.model';
import { Select } from '@ngxs/store';
import { AppState } from '../../../state/appState';
import { Observable } from 'rxjs';
import { LanguageModel } from '../../../shared/models/language.model';

@Component({
  selector: 'app-account-card',
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss'],
})
export class AccountCardComponent {
  @Input() merchant: MerchantModel;

  @Select(AppState.currentLanguage$)
  currentLanguage$: Observable<LanguageModel>;

  constructor() {}
}
